// import color from "../../../constants/color";

import color from "../../../../../constants/color"

const styles = {

  TableHead: {
    color: "#878787",
    fontWeight: "400",

  },
  dateGrid: {
    display: "flex",
    alignItems: "center",
  },
  sectionGrid: {
    px: "15px",
    pt: "20px",
    display: "flex",
    justifyContent: "space-between"
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },
  periodStatText: {
    fontSize: "12px",
    color: color.lightText,
    mt: "4px",
  },

  tabledata: {
    borderBottom: 0,
    textTransform: "capitalize"

  },
  btnSection: {
    display: "flex"
  },
  submitPdf: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.secondary,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  btnGrid: {
    textAlign: "end",
    mx: 1
  },
  submitButton: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.primary,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  bonusButton: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    // backgroundColor: color.lightText,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },

  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "0px 14px",

    },
    "& .MuiOutlinedInput-root": {
      padding: "0",
      borderRadius: "70px",


    }
  },
  dateInput: {
    width: "100%",
    mt: 1,

    // padding:2,
    "& .css-6193sp-MuiInputBase-root-MuiOutlinedInput-root ": {
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  modalInputs: {
    display: "flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",

    height: "2.5em",
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },
  },
  inputSpace: {
    "& .MuiOutlinedInput-root": {
      padding: "0px 14px"
    }

  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
  },

  viewIcon: {
    color: color.lightText,
    mx: 2
  },

  tableAvtardata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
  },
  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px"

    },
    width: "29.2em"
  },
  reason: {
    borderRadius: "8px",

    width: "100%",
    mt: 1,
    height: "4.5em",
  },
  name: {
    color: color.text,
    fontSize: "14px",
    fontWeight: "400",
    textTransform: "capitalize"

  },
  mail: {
    color: color.lightText,
    fontSize: "14px",
    fontWeight: "400"
  },
  profileAvtar: {
    mr: 1,
    border: "1px solid #878787",
    borderRadius: "50%",
    p: "9px",

  },
  filterButton: {
    display: "flex",
    backgroundColor: color.secondary,
    color: color.card,
    borderRadius: "30px",
    // width:{ xs: "50%", md: "20%" },
    marginLeft: { xs: 0, md: "8px" },
    alignItems: "center",
    paddingRight: 2,
    mb: { xs: "20px", md: 0 },

  },
  icon: {
    fill: color.card
  },
  filterContainer: {
    position: "relative"
  },
  StatBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    mb: { xs: 2, md: 2, lg: 0 },


  },
  StatBoxfirst: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    pb: "20px",
    mb: { xs: 2, md: 2, lg: 0 },

  },

  StatBoxs: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    mb: { xs: 2, md: 2, lg: 0 },

  },
  cards: {
    mt: 2
  },
  paygrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
  },
  dollarIcon: {
    color: color.primary,
    fontSize: "25px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    padding: "6px",
    width: "35px",
    height: "35px",
  },
  exportbtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.secondary,
    mr: "10px",
    fontSize: "12px",
    px: 3,
    maxWidth: "90px"

  },
  emailIcon: {
    mr: 1,
  },

  downloadIcon: {
    mr: 1,
  },
  downloadbtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    // ml: { xs: 0, md: "10px" }, 
    my: 4,
    fontSize: "12px",
  },
  paybtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    ml: { xs: 0, md: "10px" },
    fontSize: "12px",
  },


  gridContainer: {
    px: "15px",
    pt: "7px",
    pb: "25px",
    display: "flex",
    justifyContent: "space-between",
  },
  cardBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  monthlyText: {
    color: color.lightText,
    fontSize: "12px",
    fontWeight: "400",

  },
  expandIcon: {
    color: color.lightText,
    display: "flex",


  },
  cardTitle: {
    color: color.text,
    fontWeight: "700",
    fontSize: "18px"
  },
  cardSubtitle:
  {
    color: color.lightText,
    fontWeight: "400",
    fontSize: "12px"
  },

  cardSubtitles:
  {
    color: color.lightText,
    fontWeight: "500",
    fontSize: "12px"
  },


}
export default styles
